<bms-common-popup
  [icon]="data.icon"
  [title]="data.title"
  [subTitle]="data.subtitle"
  [cancelTitle]="
    data.cancelBtnVal ?? ('endorsements.response-popup.cancel' | translate)
  "
  [submitTitle]="
    data?.submitBtnVal ?? ('endorsements.response-popup.save' | translate)
  "
  (onCancelClick)="onClickClose()"
  (onSubmitClick)="outputData()"
  [isSubmitEnabled]="form.valid"
>
  <mat-card-content>
    <form [formGroup]="form">
      <!-- value -->
      <mat-form-field appearance="fill" style="width: 100%" *ngIf="data.inputType !== 'date'">
        <mat-label>{{ data.fieldName }}</mat-label>
        <input
          data-testid="value"
          type="text"
          matInput
          formControlName="value"
        />
        <mat-error *ngIf="form.controls.value.hasError('required')">
          {{ data.fieldName }}
          {{ ' is required.' }}
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill" style="width: 100%" *ngIf="data.inputType === 'date'">
        <mat-label>{{ data.fieldName }}</mat-label>
        <input
          matInput
          [matDatepicker]="picker"
          formControlName="value"
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error *ngIf="form.controls.value.hasError('required')">
          {{ data.fieldName }}
          {{ ' is required.' }}
        </mat-error>
      </mat-form-field>
    </form>
  </mat-card-content>
</bms-common-popup>
